import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import enisa from 'src/static/images/footer/banner_enisa.jpg';
import enisaEs from 'src/static/images/footer/small_enisa_es.jpg';
import enisaEu from 'src/static/images/footer/small_enisa_eu.jpg';
import logoW from 'src/static/vectors/logo-w.svg';

import './Footer.css';

const Footer = ({ isFixed = false }: { isFixed?: boolean }) => {
	return (
		<footer className={isFixed ? 'is-fixed' : ''} id="colophon">
			<nav className="container">
				<ul>
					<li>
						<img src={logoW} alt="Trueflag logo" />
					</li>
					<li>
						<Link to="/legal/terms-of-use">
							<FormattedMessage id="footer.terms-of-use" />
						</Link>
					</li>
					<li>
						<Link to="/legal/privacy-policy">
							<FormattedMessage id="footer.privacy-policy" />
						</Link>
					</li>
					<li>
						<Link to="/legal/cookie-preferences">
							<FormattedMessage id="footer.cookie-preferences" />
						</Link>
					</li>
				</ul>
			</nav>
			<div className="container-logos">
				<img className="banner" src={enisa} alt="Enisa" />
				<img className="banner-small" src={enisaEu} alt="Enisa" />
				<img className="banner-small" src={enisaEs} alt="Enisa" />
			</div>
		</footer>
	);
};

export default Footer;
